import {
  FormDataConsumer,
  SelectInput,
  TextInput,
  ValidateForm,
} from "react-admin";

import { DataKind, EnterprisePlanInvoiceKind } from "../../types";
import validators from "../../utils/Validators";
import { componentUtils } from "../component_utils";
import {
  CurrencyConversionInput,
  CurrencySelectInput,
  CustomEdit,
  CustomUtcDateTimeInput,
} from "../custom";

const kindChoices = componentUtils.generateCapitalCaseSelectChoicesFromEnum(
  EnterprisePlanInvoiceKind,
);

function EnterprisePlanInvoiceEdit() {
  const validateForm: ValidateForm = (values: any) => {
    return validators.validateDateRange(values.start_at, values.end_at);
  };

  return (
    <CustomEdit
      checkPermissionFor={DataKind.EnterprisePlanInvoice}
      validate={validateForm}
    >
      <TextInput label="Description" source="description" required />
      <TextInput
        label="Purchase Order Number"
        source="purchase_order_number"
        inputProps={{ maxLength: 256 }}
      />
      <CurrencySelectInput label="Currency" source="currency" disabled={true} />
      <FormDataConsumer>
        {({ formData, ...rest }) => (
          <CurrencyConversionInput
            label="Amount"
            source="amount_native_currency"
            currency={formData.currency}
            value={formData.amount_native_currency}
            required
          />
        )}
      </FormDataConsumer>
      <CustomUtcDateTimeInput
        label="Start At (UTC)"
        source="start_at"
        required
      />
      <CustomUtcDateTimeInput
        parseSecondsAs={59}
        label="End At (UTC)"
        source="end_at"
        required
      />
      <CustomUtcDateTimeInput label="Paid At (UTC)" source="paid_at" />
      <SelectInput label="Kind" source="kind" choices={kindChoices} required />
    </CustomEdit>
  );
}

export default EnterprisePlanInvoiceEdit;
